import { PropsWithChildren, useCallback, useEffect, useState } from "react"

import { Config, ConfigContext, defaultConfig, STORAGE_KEY } from "../contexts/config"

export default function ConfigProvider({ children }: PropsWithChildren<{}>) {
  // config state
  const [config, setConfig] = useState(defaultConfig)

  // update config
  const updateConfig = useCallback(function (val: Config) {
    // update
    setConfig(val)

    // save to localstorage
    localStorage.setItem(STORAGE_KEY, JSON.stringify(val))
  }, [])

  // load from localstorage
  useEffect(() => {
    const val = localStorage.getItem(STORAGE_KEY)

    if (!val) return
    setConfig(JSON.parse(val))
  }, [])

  return <ConfigContext.Provider value={[config, updateConfig]}>{children}</ConfigContext.Provider>
}
